'use client';
import { useLayoutState } from '../../_hooks/useLayoutState';

export const CloseButton: React.FC = () => {
  const { closeMobileMenu } = useLayoutState();

  return (
    <div
      className="absolute right-4 top-4 h-6 w-8"
      tabIndex={0}
      role="button"
      onClick={closeMobileMenu}
    >
      <div className="absolute inset-x-0 top-[2px] m-auto h-[2px] w-full translate-y-[0.57rem] -rotate-45 bg-main-100" />
      <div className="absolute inset-x-0 bottom-[2px] m-auto h-[2px] w-full translate-y-[-0.57rem] rotate-45 bg-main-100" />
    </div>
  );
};
